import React, { useState, useEffect } from 'react';
import { portalFetch } from '../lib/supabase';
import { useAuth } from '../App';

function fmtDate(iso) {
  try { return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); }
  catch { return ''; }
}

const card = { background: 'white', border: '1px solid var(--border)', borderRadius: 12, padding: '1.4rem', marginBottom: '1.2rem' };
const input = { padding: '0.7rem 0.9rem', border: '1.5px solid var(--border)', borderRadius: 8, fontSize: '0.9rem', flex: 1, minWidth: 220, color: 'var(--ink)', background: 'white' };
const brandBtn = { background: 'var(--orange)', color: 'white', border: 'none', borderRadius: 8, padding: '0.7rem 1.2rem', fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer' };
const smallBtn = { background: 'none', border: '1px solid var(--border)', borderRadius: 6, padding: '0.3rem 0.8rem', fontSize: '0.78rem', cursor: 'pointer', color: 'var(--mid)' };

export default function Team() {
  const { restaurant } = useAuth();
  const [members, setMembers] = useState(null);
  const [email, setEmail]     = useState('');
  const [busy, setBusy]       = useState(false);
  const [notice, setNotice]   = useState('');

  const load = async () => {
    const result = await portalFetch('/team');
    setMembers(result?.members || []);
  };

  useEffect(() => { if (restaurant?.id) load(); }, [restaurant?.id]);

  const invite = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    setNotice('');
    const result = await portalFetch('/team', {
      method: 'POST',
      body: JSON.stringify({ action: 'invite', email: email.trim() }),
    });
    if (result?.invited) {
      setNotice('Invite sent to ' + email.trim() + '.');
      setEmail('');
      await load();
    } else {
      setNotice('Could not send the invite. Check the email address. If it is correct, this person may already have access or be linked to another TableChat restaurant.');
    }
    setBusy(false);
  };

  const remove = async (m) => {
    if (!window.confirm('Remove access for ' + m.email + '? They will no longer be able to sign in to your reviews.')) return;
    const result = await portalFetch('/team', {
      method: 'POST',
      body: JSON.stringify({ action: 'remove', userId: m.userId }),
    });
    if (result?.removed) {
      setNotice(m.email + ' no longer has access.');
      await load();
    } else {
      setNotice('Could not remove access. Please try again.');
    }
  };

  if (restaurant?.role === 'reviews') return null;

  return (
    <div>
      <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.6rem', fontWeight: 700, marginBottom: '0.3rem' }}>Team</h1>
      <p style={{ color: 'var(--mid)', fontSize: '0.9rem', marginBottom: '1.5rem', maxWidth: 620 }}>
        Give someone access to just your Reviews, for example a social media manager.
        They can read reviews, edit AI-drafted replies and publish replies. They cannot see
        orders, menus, payouts or settings, and they cannot connect Google.
      </p>

      {notice && (
        <div style={{ fontSize: '0.85rem', color: 'var(--ink)', background: 'var(--warm)', border: '1px solid var(--border)', borderRadius: 8, padding: '0.6rem 0.9rem', marginBottom: '1rem' }}>
          {notice}
        </div>
      )}

      <div style={card}>
        <div style={{ fontSize: '0.9rem', fontWeight: 700, marginBottom: '0.7rem' }}>Invite a reviews manager</div>
        <form onSubmit={invite} style={{ display: 'flex', gap: '0.7rem', flexWrap: 'wrap' }}>
          <input
            type="email" required value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="name@example.com"
            style={input}
          />
          <button type="submit" disabled={busy} style={{ ...brandBtn, opacity: busy ? 0.6 : 1 }}>
            {busy ? 'Sending...' : 'Send invite'}
          </button>
        </form>
        <div style={{ fontSize: '0.78rem', color: 'var(--muted)', marginTop: '0.6rem' }}>
          They get an email with a link to set a password. Each email can be linked to one restaurant.
        </div>
      </div>

      <div style={card}>
        <div style={{ fontSize: '0.9rem', fontWeight: 700, marginBottom: '0.7rem' }}>People with reviews access</div>
        {members === null ? (
          <div style={{ color: 'var(--muted)', fontSize: '0.85rem' }}>Loading...</div>
        ) : members.length === 0 ? (
          <div style={{ color: 'var(--muted)', fontSize: '0.85rem' }}>No one yet.</div>
        ) : (
          members.map(m => (
            <div key={m.userId} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.6rem 0', borderTop: '1px solid var(--border)' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '0.88rem', fontWeight: 600, overflowWrap: 'anywhere' }}>{m.email}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--muted)' }}>
                  {m.accepted ? 'Active' : 'Invite sent ' + fmtDate(m.invitedAt) + ', not accepted yet'}
                </div>
              </div>
              <button onClick={() => remove(m)} style={smallBtn}>Remove</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}